import { render, staticRenderFns } from "./AuthorizePage.vue?vue&type=template&id=513f2000&scoped=true"
import script from "./AuthorizePage.vue?vue&type=script&lang=ts"
export * from "./AuthorizePage.vue?vue&type=script&lang=ts"
import style0 from "./AuthorizePage.vue?vue&type=style&index=0&id=513f2000&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513f2000",
  null
  
)

export default component.exports